import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { TaskInstance, TaskStatus } from './taskSchemas';

export type ReconcileTasksPayload = {
  resources: readonly unknown[];
  allowEqualVersion?: boolean;
};

export type GetTasksSuccessPayload = {
  resources: TaskInstance[];
};

export const getTasks = createAction('TASKS_GET', getPayloadCreator());
export const getTasksSuccess = createAction('TASKS_GET_SUCCESS', getPayloadCreator<GetTasksSuccessPayload>());
export const getTasksFailure = createAction('TASKS_GET_FAILURE', getPayloadCreator<string>());
export const clearTasks = createAction('TASKS_CLEAR');
export const reconcileTasks = createAction('TASKS_RECONCILE', getPayloadCreator<ReconcileTasksPayload>());
export const transitionTask = createAction('TASKS_TRANSITION', getPayloadCreator<{ id: string; status: TaskStatus }>());
export const rollbackTask = createAction(
  'TASKS_ROLLBACK',
  getPayloadCreator<{
    id: string;
    optimisticStatus: TaskStatus;
    optimisticVersion: number;
    previousStatus: TaskStatus;
  }>(),
);
export const taskWriteSucceeded = createAction('TASKS_WRITE_SUCCEEDED');
export const taskWriteFailed = createAction('TASKS_WRITE_FAILED', getPayloadCreator<string>());
